export const UPDATE_ALL_SETTINGS = "UPDATE_ALL_SETTINGS"
export const SET_STYLE_INDEX = "SET_STYLE_INDEX"
export const UPDATE_TOOL_STATE = "UPDATE_TOOL_STATE"
